import { LinkSectionButton as Molecule } from '@components/Molecules';
import { LinkSectionButtonT } from '@components/Molecules/LinkSectionButton/types';

export const LinkSectionButton = ({ display, label, sectionId }: LinkSectionButtonT) => {
  return <Molecule display={display} label={label} sectionId={sectionId} />;
};
